import GameState from "./game-state";
import { IGame } from "../types/game";
import ChangeLevelState from "./change-level-state";

/**
 * Level up state - plays sound and triggers level change
 * Reference: quadra/source/player.cc:945-971 (Player_level_up)
 */
export default class LevelUpState extends GameState {
  private anim: number = 0;
  private readonly maxAnim: number = 220; // Matches original canvas->level_up = 220
  private changeLevelPushed: boolean = false;

  constructor(game: IGame) {
    super(game);
    // Reference: quadra/source/player.cc:945-948
    // Set level_up animation counter (used for sprite animation)
    // Note: We don't have level_up property in ICanvas, so we track it here
    
    // Play level up sound
    // Original: Player_base::play_sound(sons.levelup, -200-ugs_random.rnd(127), 0, 11000);
    // Volume: -200 to -327 (random variation of 127)
    // Pan: 0 (center)
    // Frequency: 11000 Hz
    // Play sound with frequency adjustment via playbackRate
    // Original frequency is 11000 Hz, we'll use a playbackRate that approximates 11000 Hz
    const targetFrequency = 11000; // Original target
    const playbackRate = targetFrequency / 22050; // Assuming 22050 Hz sample rate
    
    this.game.audioManager.playSound("levelup", playbackRate);
  }

  enter(): void {
    // Reference: quadra/source/player.cc:951-961 (Player_level_up::init)
    // In single player mode, call Player_change_level
    // The original uses call() which adds to the same executor
    if ((this.game as any).single && !this.changeLevelPushed) {
      // Use call() to add ChangeLevelState to the same executor (matches original)
      this.call(new ChangeLevelState(this.game));
      this.changeLevelPushed = true;
    }
  }

  update(frameTime: number): void {
    super.update(frameTime);
    
    // Reference: quadra/source/player.cc:964-970 (Player_level_up::step)
    // Decrement animation counter
    // Note: The original decrements level_up each frame, but doesn't block gameplay
    // because it runs in a parallel executor
    this.anim++;
    if (this.anim >= this.maxAnim) {
      // Animation complete, mark as done (will be removed by executor)
      // In a parallel executor, we don't call popState, we just mark as done
      // The executor will remove us when done
    }
  }
  
  /**
   * Mark state as done when animation completes
   */
  isDone(): boolean {
    return this.anim >= this.maxAnim;
  }

  paint() {
    // Reference: quadra/source/zone.cc:70-71 (blit_level_up)
    // Original draws level up sprite at position (10, level_up-30)
    // We could add a level up sprite/effect here if we have the image
  }

  toString(): string {
    return "Level Up";
  }
}

